<!-- Customer Payment Methods Section -->
<p-card styleClass="payment-methods-card">
  <ng-template pTemplate="header">
    <div class="card-header">
      <h3 class="card-title">Payment Methods</h3>
      <div class="header-actions">
        <span class="method-count">
          {{ getActivePaymentMethods().length }}
          {{ getActivePaymentMethods().length === 1 ? "method" : "methods" }}
        </span>
        @if (!readOnly) {
          <p-button
            label="Add"
            icon="pi pi-plus"
            size="small"
            (onClick)="onAdd()"
          />
        }
      </div>
    </div>
  </ng-template>

  @if (loading) {
    <div class="loading-state">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Loading payment methods...</span>
    </div>
  } @else if (!hasActivePaymentMethods()) {
    <div class="empty-state">
      <i class="pi pi-credit-card"></i>
      <span>No payment methods on file</span>
    </div>
  } @else {
    <div class="payment-methods-list">
      @for (method of getActivePaymentMethods(); track method.Id) {
        <div class="payment-method-item" [class.is-default]="method.IsDefault">
          <!-- Icon -->
          <div class="method-icon">
            <i [class]="getPaymentIcon(method)"></i>
          </div>

          <!-- Details -->
          <div class="method-details">
            <div class="method-name">
              <span
                class="method-name-text"
                [title]="getPaymentDisplay(method)"
              >
                {{ getPaymentDisplay(method) }}
              </span>
              @if (method.IsDefault) {
                <p-tag
                  value="Default"
                  severity="success"
                  [rounded]="true"
                  styleClass="default-tag"
                />
              }
              @if (isExpired(method)) {
                <p-tag
                  value="Expired"
                  severity="danger"
                  [rounded]="true"
                  styleClass="expired-tag"
                />
              }
            </div>
            @if (getExpirationDisplay(method)) {
              <div
                class="method-expiration"
                [title]="'Expires ' + getExpirationDisplay(method)"
              >
                Expires {{ getExpirationDisplay(method) }}
              </div>
            }
            @if (method.Description && method.Type !== "CreditCard") {
              <div class="method-description" [title]="method.Description">
                {{ method.Description }}
              </div>
            }
          </div>

          <!-- Actions -->
          @if (!readOnly && showDelete) {
            <div class="method-actions">
              <p-button
                icon="pi pi-trash"
                [text]="true"
                [rounded]="true"
                severity="danger"
                size="small"
                pTooltip="Delete"
                tooltipPosition="top"
                (onClick)="onDelete(method)"
              />
            </div>
          }
        </div>
      }
    </div>
  }
</p-card>
